var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [
        _vm._v(" " + _vm._s(_vm.$ct("previous-backups")) + " "),
      ]),
      _vm.backups.length == 0
        ? _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c("w-col", { attrs: { xs: "12", center: "" } }, [
                    _vm._v(" " + _vm._s(_vm.$ct("no-previous-backups")) + " "),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "w-scroll-view",
            { attrs: { tag: "w-list" } },
            _vm._l(_vm.backups, function (backup) {
              return _c(
                "w-list-item",
                { key: backup.Name },
                [
                  _c("w-list-item-text", [
                    _vm._v(
                      _vm._s(_vm.$ct("backup")) +
                        " - " +
                        _vm._s(_vm.printLocalDateTime(backup.LastModified))
                    ),
                  ]),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("restore-backup"),
                              expression: "$ct('restore-backup')",
                            },
                          ],
                          staticClass: "warning",
                          attrs: { disabled: _vm.restoreDisabled },
                          on: {
                            click: function ($event) {
                              return _vm.restoreBackup(backup)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "play" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("common.download"),
                              expression: "$ct('common.download')",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.downloadBackup(backup.Name)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "download" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }